import { z } from 'zod';
import { UserType } from '../user-types';

const RenderEnvLiveStatusSchema = z.object({
  web: z.string().nullable(),
  worker: z.string().nullable(),
  db: z.string().nullable(),
});

const RenderEnvironmentSummarySchema = z.object({
  id: z.number(),
  name: z.string(),
  displayName: z.string(),
  createdByEmail: z.string(),
  source: z.string(),
  dbMode: z.string(),
  createdAt: z.string(),
  renderServiceId: z.string().nullable(),
  renderWorkerId: z.string().nullable(),
  renderDbId: z.string().nullable(),
  liveStatus: RenderEnvLiveStatusSchema,
  url: z.string(),
  deployBranch: z.string(),
  canTeardown: z.boolean(),
});

export const RenderEnvListResponseSchema = z.object({
  myEnvironments: z.array(RenderEnvironmentSummarySchema),
  teamEnvironments: z.array(RenderEnvironmentSummarySchema),
});

export const RenderEnvTeardownResponseSchema = z.object({ ok: z.literal(true), name: z.string() });

export const RenderEnvRedeployResponseSchema = z.object({ ok: z.literal(true), message: z.string() });

export const RenderEnvVerifyDeployResponseSchema = z.object({
  live: z.boolean(),
  webStatus: z.string(),
  workerStatus: z.string(),
  url: z.string(),
  deployBranch: z.string(),
  adminSeeded: z.boolean().optional(),
});

export const RenderProdUsersResponseSchema = z.object({
  users: z.array(
    z.object({
      slackUserId: z.string(),
      ownerEmail: z.string().nullable(),
      userType: z.enum(UserType),
    })
  ),
});

export const RenderEnvDbUrlResponseSchema = z.object({ externalConnectionString: z.string() });
